export default __webpack_public_path__ + "static/media/ParceirosIFF.7ebf4a8c.png";